module.exports = __webpack_public_path__ + "img/13.a2bc0784.jpg";